import {  useState } from "react";
import { useTranslation } from "react-i18next";
import { Select } from "antd";
import DropdownIcon from "Components/DropdownIcon/DropdownIcon";

const SimpleSelect = (props) => {
  const { t } = useTranslation("Search");
  const [openState, setOpenState] = useState(false);

  return (
      <Select
      style={{ height: 32 }}
      showArrow
      getPopupContainer={() => props?.node ? props.node.current : document.getElementById('root')}
      suffixIcon={
        <DropdownIcon
          onClick={() => {
            setOpenState((prevState) => !prevState);
          }}
        />
      }
      dropdownClassName="z"
      maxTagTextLength={4}
      maxTagCount="responsive"
      onDropdownVisibleChange={setOpenState}
      open={openState}
      placeholder={t("all")}
      {...props}
    />
  );
};

export default SimpleSelect;